"use client";

import { cn } from "@/lib/utils";
import { withStopPropagation } from "@/utils/with-stop-propagation";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import { WalletIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { WalletImage } from "./wallet-image";

interface Props {
  readonly className?: string;
  readonly showDisconnect?: boolean;
}

export function ConnectDrawdownMenuItem(props: Props) {
  const { open } = useAppKit();
  const account = useAppKitAccount();
  const t = useTranslations("Sidebar.left.dropdown");

  const handleClick = withStopPropagation(async () => {
    if (account.isConnected) {
      await open({ view: "Account" });
    } else {
      await open();
    }
  });

  return (
    <DropdownMenuItem
      onClick={handleClick}
      className={cn("gap-2", props.className)}
    >
      {account.isConnected && props.showDisconnect ? (
        <WalletImage showName className="rounded-full" />
      ) : (
        !account.isConnected && (
          <>
            <WalletIcon className="size-4" />
            {t("connectWallet")}
          </>
        )
      )}
    </DropdownMenuItem>
  );
}
